let filterCounter = 0;

export function createEmptyFilter() {
  filterCounter += 1;
  return {
    id: `filter-${Date.now()}-${filterCounter}`,
    field: '',
    operator: 'eq',
    value: '',
  };
}

function cleanInValues(value) {
  const raw = Array.isArray(value) ? value : [value];
  return raw.map((item) => String(item ?? '').trim()).filter(Boolean);
}

export function normalizeFiltersForQuery(filters = []) {
  return (filters || []).flatMap((item) => {
    if (!item?.field) return [];
    const operator = item.operator || 'eq';
    if (operator === 'in') {
      const values = cleanInValues(item.value);
      if (!values.length) return [];
      return [{ field: item.field, operator: 'in', value: values }];
    }
    const value = String(item.value ?? '').trim();
    if (!value) return [];
    return [{ field: item.field, operator, value }];
  });
}

export function formatFilterSummary(filter, fieldOptions = []) {
  const fieldLabel = fieldOptions.find((item) => item.id === filter.field)?.label || filter.field;
  if (filter.operator === 'in') {
    const values = cleanInValues(filter.value);
    return `${fieldLabel} is ${values.join(', ')}`;
  }
  const operatorLabels = {
    eq: 'is',
    ne: 'is not',
    contains: 'contains',
  };
  const op = operatorLabels[filter.operator] || filter.operator;
  return `${fieldLabel} ${op} "${filter.value}"`;
}

export default normalizeFiltersForQuery;
